import { DateTimeType } from './dateTypes';
import { z } from 'zod';

export type MilageAllowance = z.infer<typeof MilageAllowance>;

export const MilageAllowance = z.object({
    validFrom: DateTimeType,
    validTo: DateTimeType,
    value: z.number(),
    unit: z.string(),
    vehicleType: z.string(),
});
